import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import {SeismicPartyDto , ContractorDto} from '@cradua/data';
import { NotificationService, ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'cradua-seismicparty-container',
  templateUrl: './seismicparty-container.component.html',
  styleUrls: ['./seismicparty-container.component.scss']
})
export class SeismicPartyContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  contractors$: Observable<ContractorDto[]>;
  seismicpartys$: Observable<SeismicPartyDto[]>;
  loading: boolean;
  isLoadingContractor$: Observable<boolean>;
  isLoadingSeismicParty$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoadingContractor$ = this.gatwayFacade.isLoadingGateway("Contractor");
    this.isLoadingSeismicParty$ = this.gatwayFacade.isLoadingGateway("SeismicParty");

    this.contractors$ = this.gatwayFacade.loadGateway("Contractor");
    this.seismicpartys$ = this.gatwayFacade.loadGateway("SeismicParty");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteSeismicParty(deletedValue: any) {
    this.gatwayFacade.remove("SeismicParty", deletedValue);
  }

// this method control both the create and update
  onSubmitSeismicParty(formValue: any) {
    const pullData = formValue.SeismicPartys;

// declare two empty array to hold update and create data
  const allUpdates = [] ;
  const addAllSeismicParty = [];

// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id) {
      allUpdates.push(pullData[i]);
    } else {
      addAllSeismicParty.push(pullData[i]);
    }
  }

// check if the addAllSeismicParty array is not empty, then dispatch the data to the store
   if(addAllSeismicParty.length > 0) {
    this.gatwayFacade.add('SeismicParty', addAllSeismicParty);
   }

// dispatch update data to the store
   if(allUpdates.length > 0) {
    this.gatwayFacade.update('SeismicParty', allUpdates, ['id']);
   }
  }


}
